import React from "react";
import moment from "moment";
import { Tooltip, Icon } from "antd";
import { computeTitleOfHalfDay, computeTypeOfHalfDay, isUnjustified, isValidated, isProcessed } from "../utils/utils";
import { PRESENCE_STATUS_LABEL, VACATION_REQUEST_STATUS_LABELS } from "../../../configs/constants";
import { DEFAULT_END_DAY_HOUR, DEFAULT_START_DAY_HOUR, displayDurationTrip } from "../utils/date.utils";

class DayViewBadgeFactory {
  constructor(begin = DEFAULT_START_DAY_HOUR, end = DEFAULT_END_DAY_HOUR) {
    this.begin = begin;
    this.end = end;
  }
  updateBeginAndEndHour = (begin, end) => {
    this.begin = begin;
    this.end = end;
  };
  computeDiffWithStateDate = date => {
    const minutes = moment(date).format("mm");
    const hours = moment(date).format("HH");
    const diffWithStartDay = (parseInt(hours) - this.begin) * 60 + parseInt(minutes);
    return diffWithStartDay;
  };

  computePositionPx = date => {
    const diffWithStartDay = this.computeDiffWithStateDate(date);
    return parseInt((diffWithStartDay * 100) / ((this.end - this.begin) * 60));
  };
  buildBadgeObjects(elements = [], action) {
    const badges = elements.map((element, i) => {
      let style = { display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" };
      if (!element.start_date) {
        style = {
          ...style,
          width: "44%",
          position: "absolute",
          left: element.position === "morning" ? "2%" : "52%",
          top: 85
        };
      } else {
        const left = this.computePositionPx(element.start_date);
        const right = this.computePositionPx(element.end_date);
        style = {
          ...style,
          position: "absolute",
          left: `${left}%`,
          width: `${right - left}%`,
          top: element.type === "visit" ? 25 : 50
        };
      }
      return this.buildBadgeElement(element, style, action, i);
    });
    return badges;
  }
  showCurrentTime(date) {
    const now = moment();

    if (moment(date).isSame(now, "day")) {
      return (
        <div
          style={{
            position: "absolute",
            left: this.computeDiffWithStateDate(now),
            width: 10,
            height: "100%",
            top: 0,
            backgroundColor: "red"
          }}
        />
      );
    }
    return null;
  }
  separateCategories(data) {
    let attendances = [];
    let trips = [];
    let activities = [];
    let dataDay = [];
    data.map(day => {
      // Associate visits to trips
      if (day.trips.length > 0) day.trips.map(trip => (trip.associatedActivities = day.visits));

      attendances.push(day.attendances);
      trips.push(day.trips);
      activities.push(day.visits);
      dataDay.push(day);
    });

    return {
      presence: attendances,
      trips: trips,
      activities: activities,
      dataDay
    };
  }

  //green-400 : #68d391
  getBadgeColor(content) {
    let colorClasses;
    if (content.type === "visit") {
      colorClasses = "text-white bg-green-400 ";
    } else if (content.type === PRESENCE_STATUS_LABEL.NON_WORK) {
      colorClasses = "bg-purple-300 text-white ";
    } else if (content.isUnjustified && !content.processed) {
      colorClasses = "bg-red-200 text-black border border-black ";
    } else if (content.type === VACATION_REQUEST_STATUS_LABELS.PENDING || (!content.validated && !content.processed)) {
      colorClasses = "bg-gray-200 text-black border ";
    } else if (!content.validated && content.processed && content.isUnjustified) {
      colorClasses = "border-red-400 text-red-400 bg-white border-2 ";
    } else if (
      !content.validated &&
      content.processed &&
      (content.type === "trajetPerso" || content.type === PRESENCE_STATUS_LABEL.ABSENCE)
    ) {
      colorClasses = "border-red-400 text-red-400 bg-white border ";
    } else if (!content.validated && content.processed && content.type === PRESENCE_STATUS_LABEL.VACATION) {
      colorClasses = "border-yellow-500 text-yellow-500 bg-white border ";
    } else if (
      !content.validated &&
      content.processed &&
      (content.type === "trajetPro" || content.type === PRESENCE_STATUS_LABEL.ATTENDANCE)
    ) {
      colorClasses = "border-green-400 text-green-400 border ";
    } else if (content.validated && content.isUnjustified) {
      colorClasses = "bg-red-500 text-white border-black border-2 ";
    } else if (
      content.validated &&
      (content.type === "trajetPro" || content.type === PRESENCE_STATUS_LABEL.ATTENDANCE)
    ) {
      colorClasses = "text-white bg-green-400 ";
    } else if (content.type === "trajetPerso" || content.type === PRESENCE_STATUS_LABEL.ABSENCE) {
      colorClasses = "bg-red-500 text-white  ";
    } else if (content.type === PRESENCE_STATUS_LABEL.VACATION) {
      colorClasses = "bg-yellow-500 text-white  ";
    } else colorClasses = "bg-purple-300 text-white ";

    return colorClasses;
  }
  getIconColor(content) {
    let iconColor = "black";

    if (content.type === "visit") {
      iconColor = "white";
    } else if (content.type === PRESENCE_STATUS_LABEL.NON_WORK) {
      iconColor = "white";
    } else if (!content.validated && content.isUnjustified && !content.processed) {
      iconColor = "black";
    } else if (content.type === VACATION_REQUEST_STATUS_LABELS.PENDING || (!content.validated && !content.processed)) {
      iconColor = "black";
    } else if (!content.validated && content.processed && content.isUnjustified) {
      iconColor = "red";
    } else if (
      !content.validated &&
      content.processed &&
      (content.type === "trajetPerso" || content.type === PRESENCE_STATUS_LABEL.ABSENCE)
    ) {
      iconColor = "red";
    } else if (!content.validated && content.processed && content.type === PRESENCE_STATUS_LABEL.VACATION) {
      iconColor = "orange";
    } else if (
      !content.validated &&
      content.processed &&
      (content.type === "trajetPro" || content.type === PRESENCE_STATUS_LABEL.ATTENDANCE)
    ) {
      iconColor = "#68d391";
    } else if (content.validated && content.isUnjustified) {
      iconColor = "white";
    } else if (content.validated && content.type !== "trajetPerso" && content.type !== PRESENCE_STATUS_LABEL.ABSENCE) {
      iconColor = "white";
    } else if (content.type === "trajetPerso" || content.type === PRESENCE_STATUS_LABEL.ABSENCE) {
      iconColor = "white";
    } else iconColor = "white";

    return iconColor;
  }

  buildBadgeElement(content, style, action, i) {
    let classes = "rounded-full h-6 w-6 text-center py-3 truncate cursor-pointer ";
    if (content.type === "visit" && content.type_event !== "visite") {
      classes = "rounded-full h-6 w-6 text-center py-3 truncate ";
    }
    classes += this.getBadgeColor(content);
    let time = "";
    if (content.start_date && content.end_date) {
      time = `: ${displayDurationTrip(content.start_date, content.end_date)}`;
    }
    let trajet = "";
    if (content.type === "trajetPerso") {
      trajet = "perso";
    } else if (content.type === "trajetPro") {
      trajet = "pro";
    }

    return (
      <div key={i}>
        <Tooltip
          title={`${content.type_event ? `${content.type_event} > ` : ""} ${content.title} ${trajet} ${time} )`}
          key={i}
        >
          <div className={classes} style={style} onClick={() => action(content)}>
            {content.type === "visit" ? (
              content.type_event !== "visite" ? (
                <Icon type="gold" theme="twoTone" twoToneColor={this.getIconColor(content)} />
              ) : (
                // <Icon type="calendar" />
                <Icon type="shop" theme="twoTone" twoToneColor={this.getIconColor(content)} />
              )
            ) : content.type === "trajetPerso" || content.type === "trajetPro" ? (
              <Icon type="car" theme="twoTone" twoToneColor={this.getIconColor(content)} />
            ) : (
              content.title
            )}
          </div>
        </Tooltip>
      </div>
    );
  }

  parsePresence(days) {
    let presenceBadgesPerDay = [];
    days.map(day => {
      let presenceBadges = [];
      Object.keys(day.attendances).map(period => {
        const attendances = day.attendances || {};
        presenceBadges.push({
          start_date: null,
          end_date: null,
          position: period,
          validated: isValidated(attendances[period]),
          processed: isProcessed(attendances[period]),
          type: computeTypeOfHalfDay(day, period),
          title: computeTitleOfHalfDay(day, period),
          isUnjustified: isUnjustified(day, period)
        });
      });
      presenceBadgesPerDay.push(presenceBadges);
    });

    return presenceBadgesPerDay;
  }

  parseTrips(day) {
    let tripBadgesPerDay = [];
    day.map(trips => {
      let tripBadges = [];
      trips.map(trip => {
        tripBadges.push({
          id: trip.id,
          start_date: trip.start_date,
          end_date: trip.end_date,
          type: trip.type.id === 1 ? "trajetPro" : "trajetPerso",
          validated: trip.validated,
          processed: trip.processed,
          distance: trip.distance,
          title: "Trajet",
          activities: trip.associatedActivities,
          path: trip.path
        });
      });
      tripBadgesPerDay.push(tripBadges);
    });
    return tripBadgesPerDay;
  }

  parseActivity(day) {
    let activityBadgesPerDay = [];
    day.map(activities => {
      let activityBadges = [];
      activities.map(activity => {
        activityBadges.push({
          start_date: activity.startDate,
          end_date: activity.endDate,
          type: "visit",
          type_event: activity.event_type_label,
          subtype_event: activity.event_sous_type_label,
          _id: activity._id,
          title: activity.pdc_label
        });
      });
      activityBadgesPerDay.push(activityBadges);
    });
    return activityBadgesPerDay;
  }
}
export default DayViewBadgeFactory;



// WEBPACK FOOTER //
// src/modules/presence/presence/DayViewBadgeFactory.js